import { FORM_FIELDS, FORM_FIELDS_NAMES } from './site-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const NEW_SITE_BASE_INFO_INPUTS = ({ t, isAdmin = false }): IFormInputProps[] => {
	return [
		{
			key: FORM_FIELDS.NAME,
			fieldName: FORM_FIELDS.NAME,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.NAME)}`,
			label: t(FORM_FIELDS_NAMES.NAME),
			inputType: InputType.Text,
			required: true,
			additionalClasses: isAdmin && 'col-md-4',
			// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
			autoComplete: 'organization'
		},
		{
			key: FORM_FIELDS.DESCRIPTOR,
			fieldName: FORM_FIELDS.DESCRIPTOR,
			placeholder: `${t('NEW_APPLICATION.ENTER')} descriptor`,
			label: t(FORM_FIELDS_NAMES.DESCRIPTOR),
			inputType: InputType.Text,
			required: true,
			additionalClasses: isAdmin && 'col-md-4',
			autoComplete: 'organization'
		},
		{
			key: FORM_FIELDS.CITY,
			fieldName: FORM_FIELDS.CITY,
			placeholder: `${t('NEW_APPLICATION.ENTER')} city`,
			label: t(FORM_FIELDS_NAMES.CITY),
			inputType: InputType.Text,
			required: true,
			additionalClasses: isAdmin && 'col-md-4',
			autoComplete: 'address-level2'
		}
	];
};
